module.exports = __webpack_public_path__ + "img/NMI_gongjing_2021.770e391c.jpg";